/**
 * `exactOptionalPropertyTypes: true` (tsconfig.base.json) makes
 * `<Input error={maybeUndefined} />` a type error when `InputProps['error']`
 * is `string | undefined` implicit-optional (`error?: string`, not `error?:
 * string | undefined`) — several `@xdocs/ui` primitives (Input/Field) are
 * authored that way (their own docstrings note the opposite convention
 * where it matters). Spreading `{}` vs `{ key: value }` is the sanctioned
 * way to satisfy "present with a value, or entirely absent" instead of
 * "present with `undefined`".
 */
export function optionalProp<K extends string, V>(key: K, value: V | undefined): { [P in K]?: V } {
  return value === undefined ? {} : ({ [key]: value } as { [P in K]?: V });
}
